// @ts-strict-ignore
import clsx from 'clsx'
import { FC, ReactNode, useEffect, useMemo, useState } from 'react'

import { Question } from '@/shared/lib/@deprecated/iport-icons'

import cl from './Tip.module.scss'

interface TooltipProps {
	children: ReactNode
	Icon?: ReactNode
	tooltipPosition?: string
	onXLPosition?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'top' | 'bottom'
	onSMPosition?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'top' | 'bottom'
	disableOnTouch?: boolean
}

/* eslint-disable */
const Tooltip: FC<TooltipProps> = ({
	children,
	Icon,
	tooltipPosition = 'topRight',
	onXLPosition,
	onSMPosition,
	disableOnTouch
}) => {
	const [isVisible, setIsVisible] = useState(false)
	const [currentPosition, setCurrentPosition] = useState(tooltipPosition)

	const styleTooltip = isVisible && cl.tooltip_show

	const positionPresetsStyle = useMemo(() => {
		return {
			topLeft: clsx(cl.tooltip, styleTooltip, cl.tooltip_topLeft),
			topRight: clsx(cl.tooltip, styleTooltip, cl.tooltip_topRight),
			bottomLeft: clsx(cl.tooltip, styleTooltip, cl.tooltip_bottomLeft),
			bottomRight: clsx(cl.tooltip, styleTooltip, cl.tooltip_bottomRight),
			top: clsx(cl.tooltip, styleTooltip, cl.tooltip_top),
			bottom: clsx(cl.tooltip, styleTooltip, cl.tooltip_bottom)
		}
	}, [styleTooltip])

	const handleMouseEnter = () => {
		if (
			disableOnTouch &&
			(window.matchMedia('(hover: none), (pointer: coarse)').matches || navigator.maxTouchPoints > 0)
		) {
			return
		}

		setIsVisible(true)
	}

	const handleMouseLeave = () => {
		setTimeout(() => {
			setIsVisible(false)
		}, 1000)
	}

	const handleSetInvisible = () => {
		setIsVisible(false)
	}

	const handleResize = () => {
		const screenWidth = window.innerWidth
		if (onXLPosition && onSMPosition) {
			setCurrentPosition(screenWidth < 1200 ? (screenWidth < 576 ? onSMPosition : onXLPosition) : onXLPosition)
		} else if (onXLPosition && !onSMPosition) {
			setCurrentPosition(screenWidth < 1200 ? onXLPosition : currentPosition)
		} else if (onSMPosition && !onXLPosition) {
			setCurrentPosition(screenWidth < 576 ? onSMPosition : currentPosition)
		}
	}

	useEffect(() => {
		window.addEventListener('resize', handleResize)

		return () => {
			window.removeEventListener('resize', handleResize)
		}
		// eslint-disable-line react-hooks/exhaustive-deps
	}, [])

	return (
		<span className={cl.tooltipContainer} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
			{Icon ? Icon : <Question size={24} />}
			<span
				role="tooltip"
				className={positionPresetsStyle[currentPosition]}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				onClick={handleSetInvisible}>
				{children}
			</span>
		</span>
	)
}

export default Tooltip
